import { DefaultTheme, ThemeProps } from 'styled-components';

import { applyOpacity } from 'utils/styling';

export abstract class ThemeTokens {
  static spacing(key: keyof DefaultTheme['spacings']) {
    return ({ theme }: ThemeProps<DefaultTheme>) => {
      return theme.spacings[key];
    };
  }

  static fontWeight(key: keyof DefaultTheme['fontWeights']) {
    return ({ theme }: ThemeProps<DefaultTheme>) => {
      return theme.fontWeights[key];
    };
  }

  static fontSize(key: keyof DefaultTheme['fontSizes']) {
    return ({ theme }: ThemeProps<DefaultTheme>) => {
      return theme.fontSizes[key];
    };
  }

  static radius(key: keyof DefaultTheme['radius']) {
    return ({ theme }: ThemeProps<DefaultTheme>) => {
      return theme.radius[key];
    };
  }

  static color(key: keyof DefaultTheme['colors']) {
    return ({ theme }: ThemeProps<DefaultTheme>) => {
      return theme.colors[key];
    };
  }

  static opaqueColor(key: keyof DefaultTheme['colors'], opacity: number) {
    return ({ theme }: ThemeProps<DefaultTheme>) => {
      return applyOpacity(theme.colors[key], opacity);
    };
  }
}
